import { useNavigate, useLocation } from "react-router-dom";
import luniwaveLogo from "../assets/logo_rond.png";
import { useAuth } from "react-oidc-context";

export function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();

  const isActive = (path) => location.pathname.toLowerCase() === path.toLowerCase();

  const logout = () => {
    auth.signoutRedirect();
  };

  // Navigation simplifiée avec des sections claires
  const navigationItems = [
    {
      title: "Hotels",
      items: [
        {
          path: "/hotels",
          label: "Liste des hôtels",
        },
        {
          path: "/performances",
          label: "Suivi de performance",
        },
        {
          path: "/mails-success",
          label: "Mails success",
        },
      ],
    },
    {
      title: "🚿 LuniShower",
      items: [
        {
          path: "/lunishower",
          label: "Liste des hôtels",
        },
      ],
    },
    {
      title: "🌱 GreenMiles",
      items: [
        {
          path: "/greenmiles",
          label: "Liste des hôtels",
        },
        {
          path: "/greenmiles/demos",
          label: "Gestion des démos",
        },
        {
          path: "/greenmiles/sejours",
          label: "Séjours",
        },
        {
          path: "/greenmiles/statistiques",
          label: "Statistiques",
        },
      ],
    },
    {
      title: "🖼️ Images",
      items: [
        {
          path: "/images",
          label: "Uploader des images",
        },
      ],
    },
    {
      title: "📱 Plateforme Luniwave",
      items: [
        {
          path: "/luniapp/access",
          label: "Gestion des accès",
        },
      ],
    },
  ];

  return (
    <div className="h-screen w-full max-w-[22rem] shadow-xl shadow-blue-gray-900/5 bg-[#98B77F] flex flex-col overflow-hidden">
      {/* Header */}
      <div className="flex-shrink-0 p-3 sm:p-4 flex items-center border-b border-[#365644]/20">
        <button onClick={() => navigate("/hotels")} className="cursor-pointer hover:w-10 h-10 hover:animate-spin transition-all">
          <img src={luniwaveLogo} alt="Luniwave Logo" className="w-8 h-8 sm:w-10 sm:h-10" />
        </button>
        <h5 className="text-lg sm:text-xl font-bold text-[#365644] ml-3 cursor-pointer" onClick={() => navigate("/hotels")}>
          LuniManager
        </h5>
      </div>

      {/* Navigation - scrollable */}
      <nav className="flex-1 overflow-y-auto overflow-x-hidden px-3 py-3 sm:px-4 sm:py-4 space-y-3 sm:space-y-4">
        {navigationItems.map((section, sectionIndex) => (
          <div key={sectionIndex} className="space-y-1.5 sm:space-y-2">
            {/* Titre de section */}
            <h6 className="text-xs sm:text-sm font-semibold text-[#365644] px-2 sm:px-3 py-1 sm:py-2 uppercase tracking-wide border-b border-[#365644]/20">{section.title}</h6>

            {/* Items de navigation */}
            <div className="space-y-1 sm:space-y-1.5">
              {section.items.map((item) => (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={`
                    w-full text-left px-3 py-2 sm:px-4 sm:py-3 rounded-md sm:rounded-lg transition-all duration-200 border text-sm sm:text-base
                    ${isActive(item.path) ? "bg-white text-[#365644] shadow-md sm:shadow-lg border-white font-semibold" : "bg-white/10 text-[#365644] border-white/20 hover:bg-white/20 hover:border-white/40 hover:shadow-sm sm:hover:shadow-md"}
                  `}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="flex-shrink-0 p-3 sm:p-4 border-t border-[#365644]/20">
        <button onClick={logout} className="w-full h-10 sm:h-12 bg-red-600 text-white rounded-md sm:rounded-lg hover:bg-red-700 transition duration-300 flex items-center justify-center font-medium text-sm sm:text-base shadow-md border border-red-700">
          Déconnexion
        </button>
        <p className="text-xs text-[#365644]/70 text-center mt-2 sm:mt-3">LuniManager v.2.8.0</p>
      </div>
    </div>
  );
}
